module.exports = __webpack_public_path__ + "img/insta_logo.2f9b77da.png";